import TagManager from 'react-gtm-module';

/**
 * html lang tag has been updated at this point in switch-language
 */
export const setupTagManager = () => {
  TagManager.initialize({ gtmId: 'GTM-PGZ48VG' });
}